import React from 'react'
import { Tabs } from 'antd';
import { Loader } from '../Loader/Loader'

const Promo = ({ loader, setCollapsed }) => {
    const items = [
        {
            key: '1',
            label: 'AVAILABLE',
            children: <div className=''>
                <div className='promo-card'>
                    <div className=' promo-txt'>
                        Promo code<span>Exclusive</span>
                    </div>
                    <div className='promo-desc'>
                        Bonus up to 110%
                    </div>
                    <div className='text-right display-4' style={{ marginRight: "-3px" }}>
                        <svg width="33" height="60" viewBox="0 0 33 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M31.0939 1.22083C23.2242 1.03243 15.6019 3.97798 9.90396 9.4095C4.20601 14.841 0.899091 22.3136 0.710692 30.1833C0.522292 38.053 3.46784 45.6752 8.89936 51.3732C14.3309 57.0712 23.1303 59.8115 31 59.9999L31 30.9999L31.0939 1.22083Z" fill="#B13DF3" />
                            <path d="M28.4731 25.962L26.6783 24.1816C26.1467 24.7132 25.5008 24.9792 24.7413 24.9792C23.9816 24.9792 23.3361 24.7132 22.8045 24.1816C22.2725 23.6498 22.0068 23.0042 22.0068 22.2445C22.0068 21.4847 22.2728 20.8391 22.8045 20.3072L21.0238 18.5269C20.6721 18.1756 20.2426 17.9999 19.7348 17.9999C19.2268 17.9999 18.7972 18.1757 18.4459 18.5269L5.52711 31.4313C5.17565 31.7828 5 32.2127 5 32.7202C5 33.2282 5.17565 33.6577 5.52711 34.0092L7.3075 35.804C7.83931 35.2724 8.48505 35.0064 9.24469 35.0064C10.0043 35.0064 10.6499 35.2721 11.1816 35.804C11.7133 36.3357 11.9792 36.9814 11.9792 37.7411C11.9792 38.5008 11.7134 39.1461 11.1816 39.6781L12.9764 41.4728C13.3278 41.8241 13.7575 41.9998 14.2655 41.9998C14.7736 41.9998 15.2033 41.8241 15.5545 41.4728L28.4731 28.5399C28.8245 28.1886 29 27.759 29 27.251C29 26.7429 28.8244 26.3134 28.4731 25.962ZM24.6131 28.8106L15.8108 37.6127C15.64 37.7839 15.4264 37.8693 15.1698 37.8693C14.9136 37.8693 14.7 37.7839 14.529 37.6127L9.3728 32.457C9.19236 32.2763 9.10221 32.0628 9.10221 31.8161C9.10221 31.5692 9.19236 31.3553 9.3728 31.1748L18.1751 22.3726C18.3461 22.2016 18.5599 22.1161 18.8163 22.1161C19.0725 22.1161 19.2862 22.2016 19.4572 22.3726L24.6131 27.5286C24.7938 27.7092 24.8839 27.9228 24.8839 28.1697C24.8838 28.4165 24.7937 28.6301 24.6131 28.8106Z" fill="black" />
                            <path d="M18.8177 23.6691L23.3187 28.1698L15.1717 36.3169L10.6709 31.8161L18.8177 23.6691Z" fill="black" />
                        </svg>

                    </div>
                </div>

            </div>,
        },
        {
            key: '2',
            label: 'HISTORY',
            children: <div className='no-promo'>
                You have no activated
                promo yet
            </div>,
        },

    ];

    const onChange = key => {
        console.log(key);
    };

    return (
        <>
            {loader ?
                <Loader /> :
                <>
                    <div className='display-5 p-20 trad-pos'>
                        <div className='side-title'>
                            Promo
                        </div>
                        <div className='cursor' onClick={() => setCollapsed(true)} id='cs'>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z" fill="#82858E" stroke="#82858E" stroke-width="1.5294" />
                            </svg>
                        </div>
                    </div>
                    <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='promo-tab' style={{ height: "100%" }}
                        id='cs'

                    />;
                </>}
        </>
    )
}

export default Promo